import {Header, SpinningLoader} from '@/components';

import {DocumentList} from '../DocumentList';
import BusinessUserKYCSummary from './KYCSummary';
import useMerchantKYC from './useMerchantKYC';

export default function MerchantKYCScreen() {
  const {
    loading,
    userDetails,
    updateUserKYC,
    requestAdditionalDocuments,
    loadingKYC,
    userId,
    updateUserFlag,
    userLoadingFlags,
    IdType,
    fileUrls,
  } = useMerchantKYC();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <SpinningLoader />
      </div>
    );
  }
  return (
    <main className="px-3 pt-3 my-8">
      <Header
        dataCy="merchant-kyc-details-title"
        title="Business KYC Details"
      />
      <BusinessUserKYCSummary
        user={userDetails}
        onSubmit={updateUserKYC}
        onRequestAdditionalDocuments={requestAdditionalDocuments}
        isKycSubmitting={loadingKYC}
        userId={userId}
        userSelfie={''}
        onFlagUpdate={updateUserFlag}
        userLoadingFlags={userLoadingFlags}
        idType={IdType}
      />
      <DocumentList title="Uploaded Document(s)" items={fileUrls} />
    </main>
  );
}
